export enum GoalProgressView {
  pillOnly = "pillOnly",
  pillAndProgressText = "pillAndProgressText",
  pillAndProgressBar = "pillAndProgressBar",
}
